import { Injectable } from '@angular/core';
import { catchError, switchMap, map, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { AuthEntitiesService } from '../../services/auth-entities.service';
import { LoginEntityActions } from './login-entity.actions';

@Injectable()
export class LoginEntityEffects {
  constructor(private actions$: Actions, private authEntitiesService: AuthEntitiesService) {}

  getLoginEntityStart$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LoginEntityActions.get_entity_start),
        switchMap(() =>
          this.authEntitiesService.getLoginEntity().pipe(
            map(entities => LoginEntityActions.get_entity_success({ entity: entities.find(x => x.EntityTypeKey === 'UserLogin') })),
            catchError(error => of(LoginEntityActions.get_entity_fail({ error: error })))
          )
        )
      ),
    { dispatch: true }
  );

  getLoginEntityFail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LoginEntityActions.get_entity_fail),
        tap(data => {
          throw data.error;
        })
      ),
    { dispatch: false }
  );
}
